export default __webpack_public_path__ + "static/media/phone-6.984e7f4c.svg";